<h2 class="uppercase">
  Nuevo Equipo
</h2>
<form action="#" [formGroup]="newTeamForm" autocomplete="off" (submit)="saveTeam()">
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="1rem">

    <div class="w-100" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Nombre del Equipo:</span>
      <mat-form-field fxFlex>
        <input matInput type="text" formControlName="name">
        <mat-error *ngIf="newTeamForm.get('name').hasError('required')">
          Nombre requerido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-100" fxLayout="row nowrap" fxLayoutGap="1rem" fxLayoutAlign="start center">
      <span fxFlex="20">Administrador Equipo:</span>
      <mat-form-field fxFlex>
        <input type="text" matInput formControlName="owner" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUsername">
          <mat-option *ngFor="let player of filteredPlayers | async" [value]="player">
            {{player.username}}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="newTeamForm.get('owner').hasError('required')">
          Administrador requerido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="2rem">
      <button type="button" mat-button class="uppercase" (click)="closeDialog()">Cancelar</button>
      <button mat-raised-button color="primary" [disabled]="!newTeamForm.valid" type="submit" class="uppercase">Guardar</button>
    </div>
  </div>
</form>